module.exports = __webpack_public_path__ + "static/media/cod.a2529f24.jpg";